module.exports = __webpack_public_path__ + "img/fmcg_icon03.99ca4c83.png";